<script setup>
    /**
     * Vue Scripts
     */
    import {computed} from "vue";
    import {trialStore} from "@pinia/trial-store";

    /**
     * Vue Components
     */
    import Location from "@pages/Trial/TrialMap/Listing/Locations/Location/Location.vue";
    import Loading from "@component/Loading/Loading.vue";

    const {noLocationsText} = TRIAL;

    const store = trialStore()
    const locations = computed(() => store.locations)
    const loading = computed(() => store.loading)

    //region Flex Trial Colors
    let scrollColorClass = [];

    if (typeof TRIAL_COLORS !== 'undefined') {
        scrollColorClass.push(TRIAL_COLORS.scrollColor);
    }
    //endregion
</script>

<template>
    <div
        id="locations-listing"
        class="location-section"
        :class="scrollColorClass.length && scrollColorClass.join(' ')"
    >
        <Loading :loading="loading" />

        <Location
            v-if="!loading && locations.length"
            v-for="({address, coords, directions, distance, facility, phone, reifyLocationId}, index) in locations"
            :key="index"
            :address="address"
            :coords="coords"
            :directions="directions"
            :distance="distance"
            :facility="facility"
            :index="index"
            :phone="phone"
            :reify-location-id="reifyLocationId"
        />

        <div v-if="!loading && !locations.length"
             class="no-results">
            <div class="location">
                <p v-html="noLocationsText" />
            </div>
        </div>

        <!-- STUDYTEAM: Reify Form Component -->
        <studyteam-form></studyteam-form>
    </div>
</template>

<script>
    export default {
        name: "Locations"
    }
</script>

<style scoped lang="scss">

</style>
